// extracted by mini-css-extract-plugin
export var active = "QuotingTools-module--active--SpoZO";
export var article = "QuotingTools-module--article--mxjkw";
export var desc = "QuotingTools-module--desc--9UuDE";
export var grid = "QuotingTools-module--grid--1GGVn";
export var header = "QuotingTools-module--header--Vp8X7";
export var nav = "QuotingTools-module--nav--92GZo";
export var notice = "QuotingTools-module--notice--d0SJz";
export var toc = "QuotingTools-module--toc--+0GdE";